import { useState, useEffect } from 'react';
import searchStorage from '@Services/SearchStorage';

export default function useSearchObjectFromStorage({ searchId }) {
  const [searchObject, setSearchObject] = useState(null);
  const [searchObjectReady, setSearchObjectReady] = useState(false);

  useEffect(() => {
    searchStorage
      .get(searchId)
      .then((object) => {
        setSearchObject(object);
      })
      .catch(Logger.error)
      .finally(() => {
        setSearchObjectReady(true);
      });
  }, [searchId]);

  return [searchObject, searchObjectReady];
}
